import { CorpUIResponse } from 'src/types/Corp';
import { ROLES_LIST } from 'src/components/enterprise/features/Employee/utils/employeeRoles.utils';
import { Employee } from 'src/types/Employee';

export type EmployeeInfo = {
  id?: string;
  name: string;
  email: string;
  role?: string;
  allocations?: string;
  departmentId?: string;
  locationId?: string;
  department?: string;
  location?: string;
};

const getEmployeeName = (employeeData: Employee): string => {
  return `${employeeData.firstName.trim()} ${employeeData.lastName.trim()}`;
};

const getEmployeeRole = (employeeData: Employee): string => {
  return ROLES_LIST.find((role) => role.value === employeeData.role).text;
};

const getEmployeeAllocation = (
  employeeData: Employee,
  corpData: CorpUIResponse
): string => {
  const corpAllocationsPermitted = corpData.allocationsPermitted;

  if (!corpAllocationsPermitted) {
    return '';
  }

  const employeeAllocationsPermitted =
    employeeData?.corpDinerSettings?.allocationsPermitted;

  return employeeAllocationsPermitted ? 'Enabled' : 'Disabled';
};

export const extractEmployeeInfo = (
  employeeData: Employee,
  corpData: CorpUIResponse,
  departmentName?: string | null,
  locationName?: string | null
): EmployeeInfo => {
  const allocations = getEmployeeAllocation(employeeData, corpData);
  return {
    ...(employeeData.internalId && { id: employeeData.internalId }),
    name: getEmployeeName(employeeData),
    email: employeeData.email,
    role: getEmployeeRole(employeeData),
    ...(allocations && { allocations }),
    ...(employeeData.departmentId && {
      departmentId: employeeData.departmentId,
    }),
    ...(employeeData.locationId && { locationId: employeeData.locationId }),
    ...(departmentName && { department: departmentName }),
    ...(locationName && { location: locationName }),
  };
};
